<script setup>
/**
 * Anchors a child element (e.g. a FAB) to a fixed position within the scrollable page.
 *
 * @status recommended
 * @group layout
 * @useWhen Pinning a floating action button or other element to a fixed position on the page
 * @within hr-layout hr-page-container hr-page
 * @see https://quasar.dev/layout/page-sticky Quasar q-page-sticky API
 */
defineOptions({ name: 'HrPageSticky' });
</script>

<template>
  <q-page-sticky v-bind="$attrs">
    <!-- @slot The element to pin at the fixed position. -->
    <slot />
  </q-page-sticky>
</template>
